// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Minus from '../_raw/ui/icon_minus.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Minus);
